export default __webpack_public_path__ + "static/media/dozule6.2ec6464c.jpg";